/* eslint-disable no-useless-escape */
"use strict";
import { reactive } from "vue";
import { PersonToken } from "@/services/requests/person_token";
const DATEPART = {
    YEAR_FIRST_DAY: "first-day-year",
    YEAR_END_DAY: "end-day-year",
    MONTH_FIRST_DAY: "first-day-month",
    MONTH_END_DAY: "end-day-month",
    YEAR: "year",
    MONTH: "month",
    DAY: "day",
    HOUR: "hour",
    MINUTE: "minute",
    SECOND: "second",
};

export let appData = reactive({
    init: false,
    name: "App Name",
    version: "1.00.000",
    cacheVersion: "",
    base: "",
    mediaBase: "",
    meetBase: "",
    serverBase: "",
    now: new Date(),
    dateDiff: 0,
    list: {},
    page: {},
    default: {
        img: "/assets/img/empty.jpg",
        profile: "/assets/img/profile.png",
        logo: "/assets/img/logo.png",
        currency() {
            return "₺";
        },
        msg: {
            noAccess: 'Yetkiniz bulunmamaktad\u0131r!',
            noRecord: 'Kay\u0131t bulunmamad\u0131!',
            noDeleteRecord: 'Silinecek kay\u0131t bulunamad\u0131!',
            noValidRecord: 'Bu kay\u0131t ge\u00E7erli de\u011Fil!',
            noConnect: '\u0130nternet Ba\u011Flant\u0131s\u0131 Yok!',
            dataSave: 'Bilgiler kaydedildi.',
            dataSaveFailed: 'Bilgiler kaydedilmedi!',
            dataDelete: 'Bilgiler silindi.',
            dataDeleteFailed: 'Bilgiler silinemedi!',
            dataGet: 'Bilgiler getirildi.',
            dataGetFailed: 'Bilgiler getirilemedi!',
            processFailed: '\u0130\u015Flem ba\u015Far\u0131s\u0131z!',
        }
    },
    fn: {
        listeners: new Map(),
        main() {
            return document.querySelector(".main-content");
        },
        setEvent(el, events, fnc) {
            events = events.split(",");
            if (el) {
                if (appData.fn.listeners.has(el)) {
                    const existingListener = appData.fn.listeners.get(el);
                    events.forEach(eventName => {
                        if (existingListener[eventName]) {
                            el.removeEventListener(eventName, existingListener[eventName]);
                            delete existingListener[eventName];
                        }
                    });
                }
                else {
                    appData.fn.listeners.set(el, {});
                }
                events.forEach(eventName => {
                    appData.fn.listeners.get(el)[eventName] = fnc;
                    el.addEventListener(eventName, fnc);
                });
            }
        },

        parseJwt(token) {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return J.Parse(jsonPayload, "{}");
        },
        getLocal(key, def) {
            try { return JSON.parse(localStorage.getItem(key)) || def; }
            catch (err) { console.warn(err.message); }
            return def;
        },
        setLocal(key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        },
        removeLocal(key) {
            if (localStorage.getItem(key)) {
                localStorage.setItem(key, "");
                localStorage.removeItem(key);
            }
        },
        getSession(key, def) {
            try { return JSON.parse(sessionStorage.getItem(key)) || def; }
            catch(err) { console.warn(err.message); }
            return def;
        },
        setSession(key, value) {
            sessionStorage.setItem(key, JSON.stringify(value));
        },
        removeSession(key) {
            if (sessionStorage.getItem(key)) {
                sessionStorage.removeItem(key);
            }
        },
        create(h) {
            let d = document.createElement("DIV");
            d.innerHTML = h;
            return d.firstElementChild;
        },
        clone(p) {
            let s = p.cloneNode();
            for (let i = 0; i < p.childNodes.length; i++) {
                let e = p.childNodes[i];
                if (e.clone) {
                    s.appendChild(e.clone());
                } else {
                    s.appendChild(e.cloneNode());
                }
            }
            return s;
        },
        body() {
            return document.querySelector("body");
        },
        setViewport(minWidth) {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const viewport = document.getElementById('viewport');
            if (width <= minWidth) {
                viewport.setAttribute("content", "width=" + minWidth + ", height=device-height, initial-scale=1.0, maximum-scale=1.0, user-scalable=No");
            }
            else {
                viewport.setAttribute("content", "width=device-width, height=device-height, initial-scale=1.0, maximum-scale=1.0, user-scalable=No");
            }
        },
        get(s) {
            if (typeof s == "string") {
                return document.querySelector(s);
            }
            return s;
        },
        gets(s) {
            if (typeof s == "string") {
                return document.querySelectorAll(s);
            }
            return s;
        },
        getId(e) {
            return document.querySelector("#" + e);
        },
        getName(n) {
            return document.querySelector('[name="' + n + '"]');
        },
        getNames(n) {
            return document.querySelectorAll('[name="' + n + '"]');
        },
        getHtmlTag(html, selector, count) {
            count = C.Int(count);
            let div = new DOMParser().parseFromString(html, "text/html").documentElement;
            let list = div.querySelectorAll(selector);
            if (C.Int(count) <= 0) { return list; }
            let l = [];
            for (let i = 0; i < count && i < list.length; i++) {
                l.push(list[i]);
            }
            return l;
        },
        getJSON(u, c) {
            let x = new XMLHttpRequest();
            x.open("GET", u, true);
            x.responseType = "json";
            x.onload = function () {
                if (x.status === 200) {
                    c(x.response, 200);
                } else {
                    c(x.response, x.status);
                }
            };
            x.send();
        },
        getSCRIPT(u) {
            let s = document.createElement("script");
            s.src = u;
            s.type = "text/javascript";
            s.defer = false;
            document.getElementsByTagName("head").item(0).appendChild(s);
        },
        each(o, fn) {
            if (!o) {
                return o;
            }
            if (o.length > 0) {
                for (let i = 0; i < o.length; i++) {
                    if (fn.call(o[i], i, o[i]) === false) {
                        break;
                    }
                }
            } else if (o != null && o.length == undefined) {
                fn.call(o);
            }
            return o;
        },
        scrollStart(el, top) {
            if (el) {
                el.scrollTop = C.Int(top);
                //el.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
            }
        },
        scrollLeft(el, left) {
            if (el) {
                el.scrollLeft = C.Int(left);
            }
        },
        scrollEnd(el) {
            if (el) {
                el.scrollTop = el.scrollHeight;
                //el.scrollIntoView({ behavior: "auto", block: "end", inline: "nearest" });            
            }
        },
        autoResizeTextArea(el) {
            const minRows = 2, maxRows = 10;
            el.rows = minRows;

            // Sadece bir kez event listener eklenmesini sağla
            if(!el._autoResizeBound) {
                el.addEventListener('input', () => appData.fn.autoResizeTextArea(el));
                el._autoResizeBound = true; // özel işaret koyduk
            }

            const lineHeight = parseInt(window.getComputedStyle(el).lineHeight, 10);
            const scrollHeight = el.scrollHeight;
            const borderTop = parseInt(window.getComputedStyle(el).borderTopWidth, 10);
            const borderBottom = parseInt(window.getComputedStyle(el).borderBottomWidth, 10);
            const padding = parseInt(window.getComputedStyle(el).paddingTop, 10) + parseInt(window.getComputedStyle(el).paddingBottom, 10);

            const contentHeight = scrollHeight - borderTop - borderBottom - padding;
            const newRows = Math.min(maxRows, Math.max(minRows, Math.round(contentHeight / lineHeight)));

            el.rows = newRows;
        },
        phoneFormat(number) {
            let cleanNumber = number.replace(/\D/g, '');
            // Eğer numara 10 haneli ise, başa "0" ekleyip formatla
            if(cleanNumber.length === 10) {
                cleanNumber = '0' + cleanNumber; // Başına 0 ekle
            }
            // "0550 123 4568" formatına getir
            if (cleanNumber.length === 11) {
                return cleanNumber.replace(/^(\d{4})(\d{3})(\d{4})$/, '$1 $2 $3');
            }
            return number;
        },
        passwordInput(selector) {
            document.querySelectorAll(selector).forEach((el) => {
                if (el) {
                    const toggle = el.parentElement.querySelector(".password-toggle");
                    appData.fn.setEvent(toggle, "click", function () {
                        el.setAttribute("type", el.getAttribute("type") === "password" ? "text" : "password");
                        toggle.querySelector("i").classList.toggle("fa-eye");
                        toggle.querySelector("i").classList.toggle("fa-eye-slash");
                    });
                }
            });
        },
        phoneInput(el) {
            if (el) {
                appData.fn.setEvent(el, "input,blur", function (e) {
                    let val = el.value.replace(/\D/g, '');

                    if (val.length < 3) {
                        if (val.length > 0 && val[0] != '0') {
                            val = '';
                        }
                        else if (val.length > 1 && val[1] != '5') {
                            val = '0';
                        }
                    }
                    else {
                        val = '05' + val.replace(/^05/, '');
                    }

                    if (val.length > 11) {
                        val = val.slice(0, 11);
                    }
                    let formattedValue = '';
                    if (val.length > 0) {
                        formattedValue += val.slice(0, 4) + ' ';
                    }
                    if (val.length > 4) {
                        formattedValue += val.slice(4, 7) + ' ';
                    }
                    if (val.length > 7) {
                        formattedValue += val.slice(7);
                    }
                    el.value = formattedValue.trim();
                });
            }
        },
        numberInput(el) {
            if (el) {
                const min = el.getAttribute('min');
                const max = el.getAttribute('max');
                appData.fn.setEvent(el, "input,blur", function (e) {
                    el.beforeValue = C.Str(el.beforeValue);
                    //let val = C.Int(el.value.replace(/\D/g, ''));
                    let val = C.Int(el.value.replace(/(?!^-)[^0-9]/g, ''));
                    if (min && C.Int(min) > val) { val = ""; }
                    if (max && C.Int(max) < val) { val = el.beforeValue; }
                    el.value = C.Str(val).trim();
                    el.beforeValue = el.value;
                });
            }
        },
        formatInput(el) {
            if (el) {
                const format = new RegExp(el.getAttribute('format'), "g");
                appData.fn.setEvent(el, "input,blur", function (e) {
                    let val = el.value.replace(format, '');
                    el.value = C.Str(val).trim();
                });
            }
        },
        moneyInput(el, scale) {
            if (el) {
                const min = el.getAttribute('min');
                const max = el.getAttribute('max');
                appData.fn.setEvent(el, "input,blur", function (e) {
                    let val = C.Dec(el.value);
                    if (min && C.Dec(min) > val) { val = ''; }
                    if (max && C.Dec(max) < val) { val = ''; }
                    el.value = C.Money(val, scale);
                });
            }
        },
        tcInput(el) {
            appData.fn.setEvent(el, "input,blur", function (e) {
                let val = el.value.replace(/\D/g, '');
                if (val.length > 11) {
                    val = val.slice(0, 11);
                }
                if (val.length == 11) {
                    if (parseInt(val.slice(10, 11)) % 2 != 0) {
                        val = val.slice(0, 10);
                    }
                }
                el.value = val;
            });
        },
        ibanInput(el) {
            appData.fn.setEvent(el, "input,blur", function (e) {
                let val = el.value.replace(/\D/g, '');
                if (val.length > 24) {
                    val = val.slice(0, 24);
                }
                let formattedValue = '';
                if (val.length > 0) { // 2
                    formattedValue = 'TR';
                    formattedValue += val.slice(0, 2);
                }
                if (val.length > 2) { // 1. 4
                    formattedValue += ' ' + val.slice(2, 6);
                }
                if (val.length > 6) { // 2. 4
                    formattedValue += ' ' + val.slice(6, 10);
                }
                if (val.length > 10) { // 3. 4
                    formattedValue += ' ' + val.slice(10, 14);
                }
                if (val.length > 14) { // 4. 4
                    formattedValue += ' ' + val.slice(14, 18);
                }
                if (val.length > 18) { // 5. 4
                    formattedValue += ' ' + val.slice(18, 22);
                }
                if (val.length > 22) {
                    formattedValue += ' ' + val.slice(22, 24);
                }
                el.value = formattedValue;
                return true;
            });
        },
        cardInput(el) {
            appData.fn.setEvent(el, "input,blur", function (e) {
                let val = el.value.replace(/\D/g, '');
                let formattedNumber = '';
                for (let i = 0; i < val.length; i += 4) {
                    if (i > 0) {
                        formattedNumber += ' ';
                    }
                    formattedNumber += val.substring(i, i + 4);
                }
                el.value = formattedNumber;
                return true;
            });
        },
        isEnter(event, fnc) {
            if(event.keyCode === 13 && !event.ctrlKey && !event.shiftKey && !event.altKey) {
                fnc();
            }
        },
        examNet5(correct, wrong) {
            return parseFloat((correct - (wrong / 4.00)).toFixed(2));
        },
        examNet4(correct, wrong) {
            return parseFloat((correct - (wrong / 3.00)).toFixed(2));
        },
        getHour(p) {
            const minute = p % 60;
            const hour = (p - minute) / 60;
            return C.DoDouble(hour) + ':' + C.DoDouble(minute);
        },
        getVideoService(url) {
            if (/youtu(?:\.be|be\.com)/i.test(url)) {
                return 1;
            }
            else if (/vimeo\.com/i.test(url)) {
                return 2;
            }
            return null;
        },
        youtube: {
            getVideoId(url) {
                let videoId = null;
                const patterns = [
                    /(?:https?:\/\/(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+\/|\S*?[?&]v=)|https?:\/\/(?:www\.)?youtu\.be\/)([a-zA-Z0-9_-]{11})/i,
                    /(?:https?:\/\/(?:www\.)?youtube\.com\/(?:v\/|e(?:mbed)?)\/)([a-zA-Z0-9_-]{11})/i,
                    /(?:https?:\/\/youtu\.be\/)([a-zA-Z0-9_-]{11})/i // Youtu.be formatı
                ];
                patterns.some(pattern => {
                    const match = url.match(pattern);
                    if (match) {
                        videoId = match[1];
                        return true;
                    }
                    return false;
                });
                return videoId;
            },
            getThumbnail(url) {
                const videoId = appData.fn.youtube.getVideoId(url);
                if (videoId) {
                    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
                }
                return "/assets/img/empty.jpg"
            },
            getIframe(url) {
                const videoId = appData.fn.youtube.getVideoId(url);
                if (videoId) {
                    return `https://www.youtube.com/embed/${videoId}`;
                }
                return url;
            }
        },
        vimeo: {
            getVideoId(url) {
                let videoId = null;
                const patterns = [
                    /vimeo\.com\/(?:.*#|.*\/videos\/)?([0-9]+)/i,
                    /player\.vimeo\.com\/video\/([0-9]+)/i,
                    /vimeo\.com\/([0-9]+)/i
                ];
                patterns.some(pattern => {
                    const match = url.match(pattern);
                    if (match) {
                        videoId = match[1];
                        return true;
                    }
                    return false;
                });
                return videoId;
            },
            async getThumbnail(url) {
                const videoId = appData.fn.vimeo.getVideoId(url);
                if (videoId) {
                    try {
                        const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`);
                        const data = await response.json();
                        return data?.thumbnail_url || "/assets/img/empty.jpg";
                    } catch (e) {
                        console.error("Vimeo thumbnail fetch error:", e);
                        return "/assets/img/empty.jpg";
                    }
                }
                return "/assets/img/empty.jpg";
            },
            getIframe(url) {
                const videoId = appData.fn.vimeo.getVideoId(url);
                if (videoId) {
                    return `https://player.vimeo.com/video/${videoId}`;
                }
                return url;
            }, 
        },
    },
    cookie: {
        get(name) {
            const nameEQ = name + "=";
            const ca = C.Str(document.cookie).split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                if (c.length > 0) {
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1, c.length);
                    }
                    if (c.indexOf(nameEQ) == 0) {
                        return JSON.parse(c.substring(nameEQ.length, c.length));
                    }
                }
            }
            return null;
        },
        set(name, value, days) {
            value = JSON.stringify(value);
            let expires = "";
            if (days) {
                let date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        },
        isFind(name) {
            return document.cookie.split(';').some(c => {
                return c.trim().startsWith(name + '=');
            });
        },
        delete(name) {
            if (appData.cookie.isFind(name)) {
                appData.cookie.set(name, null);
                document.cookie = name + '=; Max-Age=-99999999;';
            }
        },
    },
    bus: {
        sessionKeys: [],
        localKeys: [],
        data: {},
        get(k, def) {
            for (const [key, value] of Object.entries(this.data)) {
                if (key == k) {
                    return value;
                }
            }
            return def;
        },
        listener: [],
        init(_sessionKeys, _localKeys) {
            if (typeof _sessionKeys === "string") { _sessionKeys = _sessionKeys.split(","); }
            if (typeof _localKeys === "string") { _localKeys = _localKeys.split(","); }
            if (_sessionKeys[0] != '') { this.sessionKeys.push(..._sessionKeys) };
            if (_localKeys[0] != '') { this.localKeys.push(..._localKeys) };

            if (window.sessionStorage) {
                let d = appData.fn.getSession("bus", {});
                for (let i = 0; i < this.sessionKeys.length; i++) {
                    this.data[this.sessionKeys[i]] = d[this.sessionKeys[i]];
                }
            }
            if (window.localStorage) {
                let d = appData.fn.getLocal("bus", {});
                for (let i = 0; i < this.localKeys.length; i++) {
                    this.data[this.localKeys[i]] = d[this.localKeys[i]];
                }
            }
        },
        onKey(_code, key, callback) {
            if (key != "") {
                this.listener.push({ code: _code, key: key, fnc: callback, set: false });
                if (C.HasObjectKey(this.data, key)) { // Daha önceden atanmış değer var ise bulup aktarıyoruz
                    if (callback) { callback({ key: key, value: this.data[key] }); }
                }
            }
        },
        on(me, callback) {
            if (typeof me._keys === "string") { me._keys = me._keys.split(","); }
            if (me._keys[0] != "") {
                this.listener.push({ me: me, code: me._code, keys: me._keys, fnc: callback, set: true });
                for (let i = 0; i < me._keys.length; i++) {
                    let key = me._keys[i];
                    if (C.HasObjectKey(this.data, key)) { // Daha önceden atanmış değer var ise bulup aktarıyoruz
                        //me[key] = this.data[key];
                        if (callback) { callback.call(me, { key: key, value: this.data[key] }); }
                    }
                }
            }
        },
        emit(_code, key, value, escape) {
            if (escape == undefined) { escape = true; }
            if (key != "") {
                this.data[key] = value;
                if (window.sessionStorage) {
                    let d = {};
                    for (const [k, v] of Object.entries(this.data)) {
                        for (let i = 0; i < this.sessionKeys.length; i++) {
                            if (k == C.Str(this.sessionKeys[i])) {
                                d[k] = v;
                                break;
                            }
                        }
                    }
                    appData.fn.setSession("bus", d ?? {});
                }
                if (window.localStorage) {
                    let d = {};
                    for (const [k, v] of Object.entries(this.data)) {
                        for (let i = 0; i < this.localKeys.length; i++) {
                            if (k == C.Str(this.localKeys[i])) {
                                d[k] = v;
                                break;
                            }
                        }
                    }
                    appData.fn.setLocal("bus", d ?? {});
                }
                if (_code) {
                    this.callListener(_code, key, escape);
                }
            }
        },
        remove(me) {
            for (let i = this.listener.length - 1; i >= 0; i--) {
                const r = this.listener[i];
                if(r.me == me) {
                    this.listener.splice(i, 1);
                }
            }
        },
        callListener(_code, key, escape) {
            for (let i = 0; i < this.listener.length; i++) {
                let listen = this.listener[i];
                if (!escape && listen.code == _code) { continue; }  // kendisinde çalışmaz

                if (listen.keys.length > 0) {
                    for (let j = 0; j < listen.keys.length; j++) {
                        if (listen.keys[j] == key) {
                            //if (listen.set) { listen.me[key] = this.data[key]; }
                            if (listen.fnc) { listen.fnc.call(listen.me, { key: key, value: this.data[key] }); }
                            break;
                        }
                    }
                } else {
                    listen.fnc(this.data[key]); // single
                }
            }
        },
    },
    session: {
        get(key, def) {
            return appData.fn.getSession("store", {})[key] ?? def;
        },
        set(key, value) {
            let data = appData.fn.getSession("store", {});
            data[key] = value;
            appData.fn.setSession("store", data);
        },
        delete(key) {
            let data = appData.fn.getSession("store", {});
            delete data[key]
            appData.fn.setSession("store", data);
        },
    },
    store: {
        get(key, def) {
            return appData.fn.getLocal("store", {})[key] ?? def;
        },
        set(key, value) {
            let data = appData.fn.getLocal("store", {});
            data[key] = value;
            appData.fn.setLocal("store", data);
        },
        delete(key) {
            let data = appData.fn.getLocal("store", {});
            delete data[key]
            appData.fn.setLocal("store", data);
        },
        arrayGet(key, def, find) {
            let data = appData.fn.getLocal("store", {});
            var l = data[key] ?? [];
            return l.find(r => { return find(r) }) ?? def;
        },
        arraySet(key, value, find) {
            let data = appData.fn.getLocal("store", {});
            var l = data[key] ?? [];
            const index = l.findIndex(r => { return find(r) });
            if (index > -1) { l[index] = value; }
            else { l.push(value); }
            data[key] = l;
            appData.fn.setLocal("store", data);
        },
        arrayRemove(key, find) {
            let data = appData.fn.getLocal("store", {});
            var l = data[key] ?? [];
            const index = l.findIndex(r => { return find(r) });
            if (index > -1) { l.splice(index, 1); }
            data[key] = l;
            appData.fn.setLocal("store", data);
        }
    },
    eventBus(keys, changed, load) {
        if (typeof keys === "string") { keys = keys.split(","); }
        let me = {
            _code: Rnd.Id(50),
            _keys: keys,
            load: load,
            get(key, def) {
                return appData.bus.get(key, def);
            },
            set(key, value) {
                appData.bus.emit(this, key, value, false);
            },
            leave() {
                appData.bus.remove(this);
            }
        };
        if (changed) {
            appData.bus.on(me, changed);
        }
        if (load) {
            setTimeout(function () {
                for (let i = 0; i < me._keys.length; i++) {
                    me.load(me._keys[i]);
                }
            }, 10);
        }
        return me;
    },
    initialize(args) { // name, version, cacheVersion, now, default
        appData.name = args.name;
        appData.version = args.version;
        appData.cacheVersion = args.cacheVersion;
        //appData.base = args.base;
        //appData.serverBase = args.serverBase;
        //appData.mediaBase = args.mediaBase;
        appData.now = C.Date(args.now);
        appData.dateDiff = D.DateDiff(DATEPART.SECOND, new Date(), args.now);
        // Sistem Dili - Datayı Etkilemez

        for (let key in args.args) {
            appData.default[key] = args.args[key];
        }
    },
});

// Dönüşüm-Convert İşlemleri
export class C {
    constructor() { }
    static IsNumeric(v) {
        let t = typeof v;
        return ("number" === t || "string" === t) && !isNaN(v - parseFloat(v));
    }
    static IsDate(v) {
        //return typeof v.getMonth === 'function';
        return v instanceof Date && !isNaN(v);
    }
    static Str(v, def) {
        if (def == null) { def = ""; }
        if (v == null) {
            return def.toString();
        }
        else if (v.toString() == "") {
            return def.toString();
        }
        return v.toString();
    }
    static Bool(v, def) {
        if (def == null) { def = false; }
        try {
            if (v == null || C.Str(v) == "") {
                return def;
            }
            else {
                v = C.Str(v).toUpperCase();
                if (v == "FALSE") {
                    return false;
                } else if (v == "0") {
                    return false;
                } else if (v == "TRUE") {
                    return true;
                } else if (v == "1") {
                    return true;
                } else if (v == "OK") {
                    return true;
                } else if (v == "YES") {
                    return true;
                } else if (v == "ON") {
                    return true;
                } else {
                    return false;
                }
            }
        } catch (e) {
            console.warn(e.message);
        }
        return def;
    }
    static Int(v) {
        const def = 0;
        try {
            if (v == null || C.Str(v) == "") {
                return def;
            }
            else if (!C.IsNumeric(v)) {
                return def;
            }
            else {
                return parseInt(v, 10);
            }
        } catch (e) {
            console.warn(e.message);
        }
        return def;
    }
    static Int0(v, def) {
        v = C.Int(v)
        if (v == 0) { return def; }
        return v;
    }
    static DecF(v, def) {
        if (def == null) { def = 0; }
        try {
            if (v == null || C.Str(v) == "") {
                return def;
            } else if (!C.IsNumeric(v)) {
                return def;
            } else {
                return parseFloat(parseFloat(v).toFixed(4));
            }
        } catch (e) {
            console.warn(e.message);
        }
        return def;
    }
    static Dec(v, def) {
        if (typeof v == "number") {
            return C.DecF(v, def);
        }
        return C.DecF(C.Str(v).replace(/\./g, "").replace(",", "."), def);
    }
    static Date(v, def, timezone = 'UTC') {
        return D.Convert(v, def, timezone);
    }
    static Money(v, scale) {
        return C.MoneyF(C.Str(C.Dec(v)).replace(".", ","), scale);
    }
    static MoneyF(v, scale) {
        scale = C.Int(scale);
        if (scale < 2) {
            scale = 2;
        }
        v = C.Str(v);
        let minus = C.Str(v).indexOf("-");
        v = v.replace("+", "").replace("-", "");
        let prefix = minus == 0 ? "-" : "";

        let p = v.split(",");
        let cent = C.Fill("0", scale);
        if (p.length == 2) {
            cent = p[1].substr(0, scale);
            if (cent.length < scale) {
                cent += C.Fill("0", scale - cent.length);
            }
        }
        v = prefix + C.InsertDot(p[0].replace(/\./g, "")) + "," + cent;
        return v;
    }
    static Fill(v, count) {
        let box = "";
        for (let i = 0; i < count; i++) {
            box += v;
        }
        return box;
    }
    static PreFill(t, count, v) {
        t = C.Str(t);
        v = C.Str(v, "0");
        if (t.length < count) {
            t = C.Fill(v, count - t.length) + t;
        }
        return t;
    }
    static InsertDot(v) {
        v = C.Str(v);
        let box = "";
        let count = v.length;
        let x = count - 1;
        for (let i = 1; i <= count; i++) {
            box = v[x] + box;
            if (i % 3 == 0 && i < count) {
                box = "." + box;
            }
            x--;
        }
        return box;
    }
    static DoDouble(v) {
        // İki Hane Yapma
        v = C.Int(v);
        if (C.Int(v) < 10) {
            return "0" + C.Str(v);
        }
        return C.Str(v);
    }
    static DoTriple(v) {
        v = C.Int(v);
        if (v < 10) {
            return "00" + C.Str(v);
        } else if (v < 100) {
            return "0" + C.Str(v);
        }
        return C.Str(v);
    }
    static SortBig(a, b, aZ, type) {
        let r = false;
        switch (C.Str(type).toLowerCase().replace(/ı/g, "i")) {
            case "int":
                r = C.Int(a) >= C.Int(b);
                break;
            case "dec":
                r = C.Dec(a) >= C.Dec(b);
                break;
            case "date":
                r = D.DateMaxEqual(D.RemoveTime(a), D.RemoveTime(b));
                break;
            case "time":
                r = D.DateMaxEqual(D.RemoveDate(a), D.RemoveDate(b));
                break;
            case "datetime":
                r = D.DateMaxEqual(a, b);
                break;
            default:
                r = Text.BigString(a, b);
                break;
        }
        if (!aZ) {
            r = !r;
        }
        return r;
    }
    static SortSmall(a, b, aZ, type) {
        let r = false;
        switch (C.Str(type).toLowerCase().replace(/ı/g, "i")) {
            case "int":
                r = C.Int(a) <= C.Int(b);
                break;
            case "dec":
                r = C.Dec(a) <= C.Dec(b);
                break;
            case "date":
                r = D.DateMinEqual(D.RemoveTime(a), D.RemoveTime(b));
                break;
            case "time":
                r = D.DateMinEqual(D.RemoveDate(a), D.RemoveDate(b));
                break;
            case "datetime":
                r = D.DateMinEqual(a, b);
                break;
            default:
                r = !Text.BigString(a, b);
                if (C.Str(a) == C.Str(b)) {
                    r = true;
                }
                break;
        }
        if (!aZ) {
            r = !r;
        }
        return r;
    }
    static ToFixed(v, scale) {
        if (scale == null) {
            scale = 2;
        }
        return C.DecF(v.toFixed(scale));
    }
    static HasObjectKey(o, key) {
        for (const [k, v] of Object.entries(o)) {
            if (k == key) {
                return true;
            }
        }
        return false;
    }
    static IsEmptyArray(v) {
        if (Array.isArray(v)) {
            return v.length <= 0;
        }
        return true;
    }
    static IdList(l) {
        let list = [];
        if(l) {
            if (typeof l == "string") {
                l = l.split(",");
            }
            for (let i = 0; i < l.length; i++) {
                const r = C.Str(l[i]);
                if (r != "") {
                    list.push(C.Int(r));
                }
            }
        }
        return list;
    }
}

// Metinsel İşlemler
export class Text {
    constructor() { }
    static IsEmpty(v) {
        return C.Str(v).trim().length <= 0;
    }
    static Rep(t, o, n) {
        // Tekrarlı Replace İşlemi
        t = C.Str(t);
        o = C.Str(o);
        n = C.Str(n);

        if (n.indexOf(o) > -1) {
            console.warn("Text.Rep: Döngüsel hata!");
        }
        n = n.replace(/\$/g, "$$$");
        while (t.indexOf(o) > -1) {
            t = t.replace(o, n);
        }
        return t;
    }
    static MultiRep(t, old, changeList) {
        t = C.Str(t);
        let p1 = C.Str(old).split(",");
        if (p1.length == changeList.length) {
            for (let i = 0; i < p1.length; i++) {
                t = Text.Rep(t, "[" + C.Str(p1[i]).trim() + "]", C.Str(changeList[i]).replace(/\[/g, "[A]"));
            }
        }
        return t.replace(/\[A\]/g, "[");
    }
    static Tr(v) {
        return C.Str(v)
            .replace(/â/g, "a")
            .replace(/ç/g, "c")
            .replace(/ı/g, "i")
            .replace(/ğ/g, "g")
            .replace(/ş/g, "s")
            .replace(/ö/g, "o")
            .replace(/ü/g, "u")
            .replace(/Â/g, "A")
            .replace(/Ç/g, "C")
            .replace(/İ/g, "I")
            .replace(/Ğ/g, "G")
            .replace(/Ş/g, "S")
            .replace(/Ö/g, "O")
            .replace(/Ü/g, "U");
    }
    static ToUpper(v) {
        return C.Str(v).replace(/i/g, "İ").replace(/ı/g, "I").toUpperCase();
    }
    static ToLower(v) {
        return C.Str(v).replace(/I/g, "ı").replace(/İ/g, "i").toLowerCase();
    }
    static TrFind(v) {
        return Text.Tr(v).toLowerCase().replace(/ı/g, "i");
    }
    static In(v, p) {
        v = C.Str(v);
        if (p == null) { p = []; }
        if (typeof p == "string") {
            p = p.split(",");
        }
        for (let i = 0; i < p.length; i++) {
            if (v == C.Str(p[i])) {
                return true;
            }
        }
        return false;
    }
    static InInt(v, p) {
        if (p == null) { p = []; }
        if (typeof p == "string") {
            p = p.split(",");
        }
        for (let i = 0; i < p.length; i++) {
            if (C.Int(p[i]) == v) {
                return true;
            }
        }
        return false;
    }
    static InList(l, p) {
        if (typeof l == "string") {
            l = l.split(",");
        }
        for (let i = 0; i < l.length; i++) {
            if (Text.In(l[i], p)) {
                return true;
            }
        }
        return false;
    }
    static InIndex(v, p) {
        v = C.Str(v);
        if (p == null) {
            p = [];
        }
        if (typeof p == "string") {
            p = p.split(",");
        }
        for (let i = 0; i < p.length; i++) {
            if (v == C.Str(p[i])) {
                return i;
            }
        }
        return -1;
    }
    static GetIndex(v, p) {
        v = C.Int(v);
        if (p == null) {
            p = [];
        }
        if (typeof p == "string") {
            p = p.split(",");
        }
        if (v >= 0 && v < p.length) {
            return p[v];
        }
        return "-";
    }
    static HtmlSummary(html, count) {
        let text = '';
        let l = appData.fn.getHtmlTag(html, 'p', 2);
        for (let i = 0; i < l.length; i++) {
            if(l[i]) {
                if (text != '') { text += ' '; }
                text += C.Str(l[i].innerText);
            }
        }
        if (text.length < count) {
            let div = document.createElement('div');
            div.innerHTML = html;                        
            div = div.querySelector(':not(h1,h2,h3,h4,h5,h6,img,script,table,ul,button)');
            if(div) { return div.innerText;  }
        }
        return text;
    }
    static Summary(v, max, extra) {
        // Özet - Kelime ve Harf Bazlı
        let v2 = "";
        if (v != null) {
            let p = C.Str(v).split(" ");
            for (let i = 0; i < p.length; i++) {
                if (v2.length + 1 + p[i].length < C.Int(max)) {
                    v2 += " " + p[i];
                } else {
                    v2 += C.Str(extra);
                    break;
                }
            }
        }
        return v2;
    }
    static WordCount(v) {
        // Kelime Sayıcı
        v = C.Str(v)
            .trim()
            .replace(/\n/g, " ")
            .replace(/\r/g, " ")
            .replace(/\t/g, " ");
        let count = 0;
        for (let i = 0; i < v.length; i++) {
            if (v[i] == " ") {
                count++;
                for (let j = i + 1; j < v.length; j++) {
                    if (v[j] != " ") {
                        i = j - 1;
                        break;
                    }
                }
                continue;
            }
        }
        if (v == "") {
            return 0;
        }
        return count + 1;
    }
    static BigString(v1, v2) {
        // Metin büyüklük kontrolü
        v1 = Text.ToUpper(Text.Tr(v1));
        v2 = Text.ToUpper(Text.Tr(v2));
        for (let i = 0; i < v1.length && i < v2.length; i++) {
            if (v1[i] != v2[i]) {
                if (v1[i].charCodeAt() > v2[i].charCodeAt()) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        if (v1.length < v2.length) {
            return false;
        }
        return true;
    }
    static HtmlBr(value) {
        return C.Str(value).replace(/\r\n/g, "<br>").replace(/\n/g, "<br>");
    }
    static ToLowerEn(v) {
        return C.Str(v).toLowerCase().replace(/ı/g, "i");
    }
    static Prefix(t, count, v) {
        v = C.Str(v, " ");
        for (let i = 0; i < count; i++) {
            t = v + t;
        }
        return t;
    }
    static Suffix(t, count, v) {
        v = C.Str(v, " ");
        for (let i = 0; i < count; i++) {
            t = t + v;
        }
        return t;
    }
    static IfIndex(index) {
        let l = [];
        if (arguments.length > 1) {
            if (Array.isArray(arguments[1])) {
                l = arguments[1];
            } else {
                for (let i = 1; i < arguments.length; i++) {
                    l.push(arguments[i]);
                }
            }
        }
        if (index < 0 || index >= l.length) {
            index = 0;
        }
        if (l.length > 0) {
            return l[index];
        }
        return "-";
    }
    static If(v) {
        let l = [];
        if (arguments.length > 1) {
            if (Array.isArray(arguments[1])) {
                l = arguments[1];
            } else {
                for (let i = 1; i < arguments.length; i++) {
                    l.push(arguments[i]);
                }
            }

            for (let i = 0; i < l.length; i++) {
                if (l[i] == v) {
                    return true;
                }
            }
        }
        return false;
    }
    static EscapeHtml(v) {
        const keys = ["ş", "Ş", "ı", "İ", "ç", "Ç", "ö", "Ö", "ü", "Ü", "Ğ", "ğ", "â", "Â",];
        const values = ["&#351;", "&#350;", "&#305;", "&#304;", "&ccedil;", "&Ccedil;", "&ouml;", "&Ouml;", "&uuml;", "&Uuml;", "&#286;", "&#287;", "&#226;", "&#194;",];
        for (let i = 0; i < keys.length; i++) {
            v = v.replaceAll(keys[i], values[i]);
        }
        return v;
    }
    static Format(v) {
        v = C.Str(v);
        for (let i = 1; i <= arguments.length; i++) {
            v = v.replaceAll("{" + (i - 1) + "}", C.Str(arguments[i]));
        }
        return v;
    }
    static LocalFormat(v) {
        v = C.Str(v);
        v = v.replace(/{UTC:([^}]+)}/g, (match, val) => {
            return `${D.DateTimeToString(C.Date(val))}`;
        });
        v = v.replace(/{UTC-D:([^}]+)}/g, (match, val) => {
            return `${D.DateToString(C.Date(val))}`;
        });
        v = v.replace(/{UTC-T:([^}]+)}/g, (match, val) => {
            return `${D.DateToString(C.Date(val))}`;
        });
        return v;
    }
}

// Tarih İşlemleri
export class D {
    constructor() { }
    static IsDate(v) {
        //return typeof v.getMonth === 'function';
        return v instanceof Date;
        //try {
        //  //return (typeof v.getMonth === 'function');
        //  if (!isNaN(v)) {
        //    if (Object.prototype.toString.call(v) === "[object Date]") {
        //      return true;
        //    }
        //  }
        //} catch (e) { console.warn(e.message); }
        //return false;
    }
    static Convert(v, def) {
        try {
            if (def == null || isNaN(def)) { def = new Date("1900-1-1"); }
            if (v == null || C.Str(v).trim() == "" || isNaN(new Date(v))) {
                return def;
            }
            else if (C.IsDate(v)) {
                if (v.getFullYear() > 1900) {
                    return new Date(v);
                }
                return def;
            }
            else {
                v = C.Str(v);
                try {
                    if (v.indexOf("T") > -1 && (v.indexOf("+") == -1 && v.indexOf("Z") == -1)) {
                        v += "+00:00";
                    }
                    if (new Date(v).getFullYear() > 1900) {
                        if (v.substring(0, 19).indexOf(".") <= -1) {
                            return new Date(v);
                        }
                    } else {
                        return def;
                    }
                } catch (e2) {
                    console.log(e2.message);
                }

                let p, k;
                if (v.indexOf(".") > -1) {
                    p = v.split(" ");
                    k = p[0].split(".");
                    if (k.length == 3) {
                        if (C.Int(k[2]) < 1000) {
                            k[2] = "1000";
                        }
                        v = k[2] + "-" + k[1] + "-" + k[0];
                        if (p.length == 2) {
                            v += " " + p[1];
                        }
                    }
                } else {
                    v = v.replace(/\//g, "-").replace(/\./g, "-");
                    p = v.split(" ");
                    k = p[0].split("-");
                    if (k.length == 3) {
                        if (C.Int(k[0]) < 1000) {
                            k[0] = "1000";
                        }
                        v = k[0] + "-" + k[1] + "-" + k[2];
                        if (p.length == 2) {
                            v += " " + p[1];
                        }
                    }
                }
                return new Date(v.replace(/\-/g, "/"));
            }
        } catch (e) {
            console.log(e.message);
        }
        return def;
    }
    static RemoveDate(v, date) {
        if (date == null) { date = D.ServerNow(); }
        return C.Date(D.DateFormat(date, false) + D.TimeFormat(v));
    }
    static RemoveTime(v) {
        return C.Date(D.DateFormat(v));
    }
    static ServerNow() {
        return D.DateAdd(DATEPART.SECOND, appData.dateDiff, new Date());
    }
    static MaxDate(isBig) {
        if (isBig) {
            return D.DateAdd(DATEPART.YEAR, 20, D.ServerNow());
        }
        return D.DateAdd(DATEPART.YEAR, 2, D.ServerNow());
    }
    static MinDate(isBig) {
        if (isBig) {
            return new Date(2000, 0, 1);
        }
        return new Date((D.ServerNow().getFullYear() - 1), 0, 1);
    }
    static DateFormat(v, isTimeZone) {
        const d = C.Date(v);
        if (isTimeZone == undefined || isTimeZone) {
            return (d.getFullYear() + "-" + C.DoDouble(d.getMonth() + 1) + "-" + C.DoDouble(d.getDate()) + "T00:00:00+00:00");
        }
        return (d.getFullYear() + "-" + C.DoDouble(d.getMonth() + 1) + "-" + C.DoDouble(d.getDate()));
    }
    static TimeFormat(v, isTimeZone, isSecond) {
        const d = C.Date(v);
        if (isTimeZone == undefined || isTimeZone) {
            return "T" + C.DoDouble(d.getHours()) + ":" + C.DoDouble(d.getMinutes()) + ":" + C.DoDouble(d.getSeconds() + "+00:00");
        }
        if (isSecond == undefined || isSecond) {
            return C.DoDouble(d.getHours()) + ":" + C.DoDouble(d.getMinutes()) + ":" + C.DoDouble(d.getSeconds());
        }
        else {
            return C.DoDouble(d.getHours()) + ":" + C.DoDouble(d.getMinutes());
        }
    }
    static DateTimeFormat(v, isTimeZone, isSecond) {
        if (isTimeZone == undefined || isTimeZone) {
            return D.DateFormat(v, false) + D.TimeFormat(v, true, isSecond);
        }
        return D.DateFormat(v, false) + " " + D.TimeFormat(v, false, isSecond);
    }
    static DateToSlimString(v, def) {
        const d = D.Convert(v);
        if (d.getDate() == 1 && d.getMonth() == 0 && d.getFullYear() == 1900 && def !== undefined) {
            return def;
        }
        return (C.DoDouble(d.getDate()) + "." + C.DoDouble(d.getMonth() + 1) + "." + d.getFullYear().toString().substr(-2));
    }
    static DateToString(v, def) {
        const d = D.Convert(v);
        if (d.getDate() == 1 && d.getMonth() == 0 && d.getFullYear() == 1900 && def !== undefined) {
            return def;
        }
        return (C.DoDouble(d.getDate()) + "." + C.DoDouble(d.getMonth() + 1) + "." + d.getFullYear());
    }
    static TimeToString(v, isSecond) {
        const d = D.Convert(v);
        if (isSecond) {
            return C.DoDouble(d.getHours()) + ":" + C.DoDouble(d.getMinutes()) + ":" + C.DoDouble(d.getSeconds());
        }
        else {
            return C.DoDouble(d.getHours()) + ":" + C.DoDouble(d.getMinutes());
        }
    }
    static DateTimeToString(v, isSecond, def) {
        const d = D.Convert(v);
        if (d.getDate() == 1 && d.getMonth() == 0 && d.getFullYear() == 1900 && def !== undefined) {
            return def;
        }
        return D.DateToString(v) + " " + D.TimeToString(v, isSecond);
    }
    static StartMonthDay(v) {
        return new Date(v.getFullYear(), v.getMonth(), 1);
    }
    static EndMonthDay(v) {
        return new Date(v.getFullYear(), v.getMonth() + 1, 0);
    }
    static StartYearDay(v) {
        return new Date(v.getFullYear(), 0, 1); // Ocak 1
    }
    static EndYearDay(v) {
        return new Date(v.getFullYear(), 11, 31); // Aralık 31
    }
    static DateDiff(part, d1, d2) {
        d1 = D.Convert(d1);
        d2 = D.Convert(d2);
        let t1, t2;
        switch (part.toLowerCase()) {
            case DATEPART.YEAR:
                let years = d2.getFullYear() - d1.getFullYear();
                return years;
            case DATEPART.MONTH:
                let months = (d2.getFullYear() - d1.getFullYear()) * 12;
                months += d2.getMonth() - d1.getMonth();
                return months;
            case DATEPART.DAY:
                t2 = d2.getTime();
                t1 = d1.getTime();
                return parseInt((t2 - t1) / (24 * 3600 * 1000));
            case DATEPART.HOUR:
                t2 = d2.getTime();
                t1 = d1.getTime();
                return C.Dec(((t2 - t1) / (3600 * 1000)).toFixed(2));
            case DATEPART.MINUTE:
                t2 = d2.getTime();
                t1 = d1.getTime();
                return parseInt((t2 - t1) / (60 * 1000));
            case DATEPART.SECOND:
                t2 = d2.getTime();
                t1 = d1.getTime();
                return parseInt((t2 - t1) / 1000);
        }
    }
    static DatePart(part, d1) {
        d1 = D.Convert(d1);
        switch (part.toLowerCase()) {
            case DATEPART.YEAR:
                return d1.getFullYear();
            case DATEPART.MONTH:
                return d1.getMonth() + 1;
            case DATEPART.DAY:
                return d1.getDate();
            case DATEPART.HOUR:
                return d1.getHours();
            case DATEPART.MINUTE:
                return d1.getMinutes();
            case DATEPART.SECOND:
                return d1.getSeconds();
        }
        return null;
    }
    static GetYear(d1) {
        return D.DatePart(DATEPART.YEAR, d1);
    }
    static GetMonth(d1) {
        return D.DatePart(DATEPART.MONTH, d1);
    }
    static GetDay(d1) {
        return D.DatePart(DATEPART.DAY, d1);
    }
    static AddYear(v, d1) {
        return D.DateAdd(DATEPART.YEAR, v, d1 ?? D.ServerNow())
    }
    static AddMonth(v, d1) {
        return D.DateAdd(DATEPART.MONTH, v, d1 ?? D.ServerNow())
    }
    static AddDay(v, d1) {
        return D.DateAdd(DATEPART.DAY, v, d1 ?? D.ServerNow())
    }
    static AddHour(v, d1) {
        return D.DateAdd(DATEPART.HOUR, v, d1 ?? D.ServerNow())
    }
    static AddMinute(v, d1) {
        return D.DateAdd(DATEPART.MINUTE, v, d1 ?? D.ServerNow())
    }
    static DateAdd(part, v, d1) {
        let date = new Date(D.Convert(d1).valueOf());
        if (v == 0) {
            return date;
        }
        switch (part.toLowerCase()) {
            case DATEPART.YEAR:
                date.setFullYear(date.getFullYear() + v);
                return date;
            case DATEPART.YEAR_FIRST_DAY:
                date.setFullYear(date.getFullYear() + v);
                return D.StartYearDay(date);
            case DATEPART.YEAR_END_DAY:
                date.setFullYear(date.getFullYear() + v);
                return D.EndYearDay(date);
            case DATEPART.MONTH:
                {
                    let endDate = D.StartMonthDay(date);
                    endDate.setMonth(endDate.getMonth() + v);
                    endDate = D.EndMonthDay(endDate);
                    if (endDate.getDate() < date.getDate()) {
                        date.setDate(endDate.getDate());
                    }
                }
                date.setMonth(date.getMonth() + v);
                return date;
            case DATEPART.MONTH_FIRST_DAY:
                date = D.StartMonthDay(date);
                date.setMonth(date.getMonth() + v);
                return date;
            case DATEPART.MONTH_END_DAY:
                date = D.StartMonthDay(date);
                date.setMonth(date.getMonth() + v);
                return D.EndMonthDay(date);
            case DATEPART.DAY:
                date.setDate(date.getDate() + v);
                return date;
            case DATEPART.HOUR:
                date.setHours(date.getHours() + v);
                return date;
            case DATEPART.MINUTE:
                date.setMinutes(date.getMinutes() + v);
                return date;
            case DATEPART.SECOND:
                date.setSeconds(date.getSeconds() + v);
                return date;
        }
        return null;
    }
    static DateEqual(d1, d2) {
        return D.DateToString(d1) == D.DateToString(d2);
    }
    static DateMinEqual(d1, d2) {
        if (D.DateToString(d1) != D.DateToString(d2)) {
            return D.Convert(d1) < D.Convert(d2);
        }
        return true;
    }
    static DateMaxEqual(d1, d2) {
        if (D.DateToString(d1) != D.DateToString(d2)) {
            return D.Convert(d1) > D.Convert(d2);
        }
        return true;
    }
    static TimeEqual(d1, d2, isSecond) {
        return D.TimeToString(D.Convert(d1), isSecond) == D.TimeToString(D.Convert(d2), isSecond);
    }
    static DateTimeEqual(d1, d2) {
        return D.DateTimeToString(d1) == D.DateTimeToString(d2);
    }
    static DateTimeMinEqual(d1, d2, isSecond) {
        if (D.DateToString(d1) != D.DateToString(d2) || !D.TimeEqual(d1, d2, isSecond)) {
            return D.Convert(d1) < D.Convert(d2);
        }
        return true;
    }
    static DateTimeMaxEqual(d1, d2, isSecond) {
        if (D.DateToString(d1) != D.DateToString(d2) || !D.TimeEqual(d1, d2, isSecond)) {
            return D.Convert(d1) > D.Convert(d2);
        }
        return true;
    }
    static HourToTime(totalHours) {
        totalHours = C.Int(totalHours);
        let hour = totalHours % 24;
        let totalDay = C.Int((totalHours - hour) / 24);
        let day = totalDay % 7;
        let week = C.Int((totalDay - day) / 7);
        let result = "";
        if (week > 0) {
            if (result != "") {
                result += " ";
            }
            result += week + " Hafta";
        }
        if (day > 0) {
            if (result != "") {
                result += " ";
            }
            result += day + " Gün";
        }
        if (hour > 0) {
            if (result != "") {
                result += " ";
            }
            result += hour + " Saat";
        }
        return result;
    }
    static CountDownToTime(d1) {
        const d2 = D.ServerNow();
        const ms = d1 - d2;
        if (ms <= 0) return "";
        const second = Math.floor(ms / 1000);
        const minute = Math.floor(second / 60);
        const hour = Math.floor(minute / 60);
        const day = Math.floor(hour / 24);
        const week = Math.floor(day / 7);
        const month = Math.floor(week / 4);

        const leapSecond = second % 60;
        const leapMinute = minute % 60;
        const leapHour = hour % 24;
        const leapDay = day % 7;
        const leapWeek = week % 4;

        let result = [];
        if (month > 0) {
            result.push(`${month} ay`);
        }
        if (leapWeek > 0) {
            result.push(`${leapWeek} hafta`);
        }
        if (month === 0 && leapDay > 0) {
            result.push(`${leapDay} gün`);
        }
        if (month === 0 && week === 0 && leapHour > 0) {
            result.push(`${leapHour} saat`);
        }
        if (month === 0 && week === 0 && day === 0 && leapMinute > 0) {
            result.push(`${leapMinute} dakika`);
        }
        if (month === 0 && week === 0 && day === 0 && hour == 0 && leapSecond > 0) {
            result.push(`${leapSecond} saniye`);
        }
        return result.join(' ');
    }
    static IsAM(d1) {
        let time = C.Int(D.TimeToString(D.Convert(d1)).replace(":", ""));
        return time < 1200;
    }
    static IsPM(d1) {
        let time = C.Int(D.TimeToString(D.Convert(d1)).replace(":", ""));
        return time > 1200;
    }
    static GetYearList(minYear, maxYearDown) {
        let d = D.ServerNow();
        let year = d.getFullYear() - C.Int(maxYearDown); // Bu yıldan -X yıl öncesi için
        let list = [];
        for (let i = year; i >= minYear; i--) {
            list.push(i);
        }
        return list;
    }
}

// Json işlemleri
export class J {
    static Clone(v) {
        return JSON.parse(JSON.stringify(v));
    }
    static Parse(v, def) {
        try {
            return JSON.parse(C.Str(v, def));
        } catch (e) {
            console.warn(e.message);
        }
        return JSON.parse(def);
    }
    static String(data, def) {
        try {
            return JSON.stringify(data);
        } catch (e) {
            console.warn(e.message);
        }
        return def;
    }
    static CloneDeep(v) {
        if (v === null || typeof v !== 'object') {
            return v;
        }
        if (v instanceof Date) {
            return Date(v);
        }
        if (Array.isArray(v)) {
            return v.map(item => J.CloneDeep(item));
        }
        const obj = {};
        for (let key in v) {
            if (v.hasOwnProperty(key)) {
                obj[key] = J.CloneDeep(v[key]);
            }
        }
        return obj;
    }
    static ParseArray(list, fnc, def) {
        if (!Array.isArray(list)) {
            list = J.Parse(list, C.Str(def, "[]"));
        }
        if (list) {
            list = list.map(r => fnc(r));
        }
        return list;
    }
    static ParseDate(list, def) {
        return J.ParseArray(list, (r) => {
            return C.Date(r);
        }, def);
    }
    static IsFind(list, data, findName) {
        if (findName == null) {
            findName = "id";
        }
        for (let i = 0; i < list.length; i++) {
            let r = list[i];
            if (findName == "") {
                if (C.Str(r) == C.Str(data)) {
                    return true;
                }
            } else {
                if (C.Str(r[findName]) == C.Str(data)) {
                    return true;
                }
            }
        }
        return false;
    }
    static Find(list, data, findName) {
        if (findName == null) {
            findName = "id";
        }
        if(list) {
            for (let i = 0; i < list.length; i++) {
                let r = list[i];
                if (findName == "") {
                    if (C.Str(r) == C.Str(data)) {
                        return r;
                    }
                } else {
                    if (C.Str(r[findName]) == C.Str(data)) {
                        return r;
                    }
                }
            }
        }
        return null;
    }
    static FindKey(list, data, name, def) {
        let findName = "id";
        name = C.Str(name, "name");
        if (def == undefined) {
            def = '';
        }
        def = C.Str(def);
        let r = J.Find(list, data, findName);
        if (r != null) {
            //for (let key in r) {
            //    if (r.hasOwnProperty(key)) {
            //        let $$v = r[key];
            //        eval('let ' + key + ' = $$v;');
            //    }
            //}
            try {
                //return C.Str(eval(name), def);
                return C.Str(r[name], def);
            } catch (e) {
                console.warn(e.message);
            }
        }
        return def;
    }
    static FindValue(list, data, name, def) {
        let findName = "id";
        let r = J.Find(list, data, findName);
        if (r != null) {
            try {
                return r[name] ?? def;
            } catch (e) {
                console.warn(e.message);
            }
        }
        return def;
    }
    static PrintFormat(list, data, format, findName, def) {
        if (findName == null) {
            findName = "id";
        }
        let r = J.Find(list, data, findName);
        if (r != null) {
            for (let key in r) {
                if (Object.prototype.hasOwnProperty.call(r, key)) {
                    format = Text.Rep(format, "{" + key + "}", r[key]);
                }
            }
            return format;
        }
        return C.Str(def, "");
    }
    static ToIndex(list, name) {
        let id = "id";
        name = C.Str(name, "name");
        let l = [];
        for (let i = 0; i < list.length; i++) {
            let p = {};
            p[id] = i;
            p[name] = list[i];
            l.push(p);
        }
        return l;
    }
    static ToName(list, name) {
        let id = "id";
        name = C.Str(name, "name");
        let l = [];
        for (let i = 0; i < list.length; i++) {
            let p = {};
            p[id] = list[i];
            p[name] = list[i];
            l.push(p);
        }
        return l;
    }
    static Delete(list, data) {
        for (let i = list.length - 1; i >= 0; i--) {
            const r = list[i];
            if (r == data) {
                list.splice(i, 1);
            }
        }
    }
    static DeleteBy(list, data, name) {
        if (name == null) { name = "id"; }
        for (let i = list.length - 1; i >= 0; i--) {
            const r = list[i];
            if (name == "") {
                if (C.Str(r) == C.Str(data)) {
                    list.splice(i, 1);
                }
            } else {
                if (C.Str(r[name]) == C.Str(data)) {
                    list.splice(i, 1);
                }
            }
        }
        return list;
    }
    static Filter(list, where) {
        let l = [];
        for (let i = 0; i < list.length; i++) {
            const $r = list[i];
            if (where($r)) {
                l.push(J.Clone($r));
            }
        }
        return l;
    }
    static FilterSingle(list, where) {
        for (let i = 0; i < list.length; i++) {
            const $r = list[i];
            if (where($r)) {
                return J.Clone($r);

            }
        }
        return null;
    }
    static Distinct(list, names) {
        let l = [];
        names = C.Str(names).split(",");
        for (let i = 0; i < list.length; i++) {
            const r = list[i];
            let isIn = false;
            for (let j = 0; j < l.length; j++) {
                const r2 = l[j];
                let isInIndex = 0;
                for (let k = 0; k < names.length; k++) {
                    const key = names[k];
                    if (r2[key] == r[key]) {
                        isInIndex++;
                    }
                }
                if (isInIndex == names.length) {
                    isIn = true;
                    break;
                }
            }
            if (!isIn) {
                let o = {};
                for (let k = 0; k < names.length; k++) {
                    const key = names[k];
                    o[key] = r[key];
                }
                l.push(o);
            }
        }
        return l;
    }
    static Order(list, az, name) {
        az = C.Bool(az); // A-dan Zye
        let x = null,
            y = null;
        let isName = C.Str(name) != "";
        for (let i = 0; i < list.length; i++) {
            if (isName) {
                x = list[i][name];
            } else {
                x = list[i];
            }
            for (let j = i + 1; j < list.length; j++) {
                if (isName) {
                    y = list[j][name];
                } else {
                    y = list[j];
                }
                let change = false;
                if (typeof x == "string") {
                    change = az ? Text.BigString(x, y) : !Text.BigString(x, y);
                } else if (D.IsDate(x)) {
                    change = az ? !D.DateMinEqual(y, x) : !D.DateMaxEqual(y, x);
                } else {
                    change = az ? C.Dec(x) > C.Dec(y) : C.Dec(x) < C.Dec(y);
                }
                if (change) {
                    let box = list[i];
                    list[i] = list[j];
                    list[j] = box;
                }
            }
        }
        return list;
    }
    static Insert(list, data, index) {
        index = C.Int(index);
        let l = [];
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                l.push(data);
            }
            l.push(list[i]);
        }
        if (index == list.length) {
            l.push(data);
        }
        return l;
    }
    static InsertSelect(list, text, textKey) {
        let j = { id: 0 };
        j[C.Str(textKey, 'name')] = text;
        return J.Insert(list, j, 0);
    }
    static AddKey(list, name) {
        if (name == null) { name = "id"; }
        let l = J.Parse(C.Str(list), "[]");
        for (let i = 0; i < l.length; i++) {
            l[i].Id = Rnd.Id(50);
        }
        return l;
    }
    static RemoveKey(list, name) {
        if (name == null) { name = "id"; }
        let l = [];
        for (let i = 0; i < list.length; i++) {
            let r = J.Clone(list[i]);
            l.push(r);
            delete l[l.length - 1][name];
        }
        return l;
    }
    static KeyFirstUpper(json) {
        let j;
        if (Array.isArray(json)) {
            j = [];
            for (let i = 0; i < json.length; i++) {
                j.push(J.KeyFirstUpper(json[i]));
            }
            return j;
        } else {
            j = {};
            for (let key in json) {
                if (Object.prototype.hasOwnProperty.call(json, key)) {
                    let key2 = key.charAt(0).toUpperCase() + key.slice(1);
                    j[key2] = json[key];
                }
            }
        }
        return j;
    }
    static Level(list, name, parentId) {
        let l = [];
        let callback = function (parent, level) {
            for (let i = 0; i < list.length; i++) {
                let r = list[i];
                if (C.Int(r[name]) == parent) {
                    let o = J.Clone(r);
                    o._level = level;
                    l.push(o);
                    callback(o.Id, level + 1);
                }
            }
        };
        callback(parentId, 0);
        return l;
    }
    static LevelChild(list, name, parentId) {
        let callback = function (parent, level) {
            let l = [];
            for (let i = 0; i < list.length; i++) {
                let r = list[i];
                if (C.Int(r[name]) == parent) {
                    let o = J.Clone(r);
                    o._level = level;
                    o.child = callback(o.Id, level + 1);
                    l.push(o);
                }
            }
            return l;
        };
        return callback(parentId, 0);
    }
    static LevelText(list, name, endId, fnc) {
        let text = '';
        let callback = function (id, first) {
            for (let i = 0; i < list.length; i++) {
                let r = list[i];
                if (C.Int(r.Id) == id) {
                    let parent = C.Int(r[name]);
                    text = fnc(r, first, parent <= 0) + text;
                    callback(parent, false);
                    break;
                }
            }
        };
        callback(endId, true);
        return text;
    }
    static LevelDelete(list, name, parentId) {
        let l = J.Clone(list);
        let callback = function (parent) {
            for (let i = 0; i < list.length; i++) {
                let r = list[i];
                if (C.Int(r[name]) == parent) {
                    callback(r.Id);
                    J.DeleteBy(l, r.Id);
                }
            }
        };
        callback(parentId);
        return l;
    }
}

//Randomize İşlemleri
export class Rnd {
    static Id(size) {
        return Rnd.Text(size, false, true);
    }
    static Next(min, max) {
        return Math.floor(Math.random() * ((max + 1) - min) + min);
    }
    static Text(size, isUpper, isId) {
        isId = C.Bool(isId);
        let text = "";
        let possible = "abcdefghijklmnopqrstuvwxyz0123456789";
        if (C.Bool(isUpper)) {
            possible = possible.toUpperCase().replace(/i/g, "I");
        }
        for (let i = 0; i < size; i++) {
            let c = possible.charAt(Math.floor(Math.random() * possible.length));
            if (isId) {
                if (C.IsNumeric(c)) {
                    i -= 1;
                    continue;
                }
            }
            text += c;
        }
        return text;
    }
    static Number(size, isZero) {
        isZero = C.Bool(isZero);
        let text = "";
        let possible = "0123456789";
        for (let i = 0; i < size; i++) {
            let c = possible.charAt(Math.floor(Math.random() * possible.length));
            if (i == 0) {
                if (isZero && c == "0") {
                    i -= 1;
                    continue;
                }
            }
            text += c;
        }
        return text;
    }
    static MakeId(size) {
        // Rasgele Id Oluştur
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        for (let i = 0; i < size; i++) {
            let c = possible.charAt(Math.floor(Math.random() * possible.length));
            if (C.IsNumeric(c)) {
                c = "A";
            }
            text += c;
        }
        return text;
    }
}